<template>
	<div class="mainApp">
		<DealsPage ref="deals_page" />
	</div>
</template>

<script>
	import DealsPage from "@/components/DealsPage.vue";

	export default {
		name: "SettlementBuyView",
		components: {
			DealsPage,
		},
		data() {
			return {};
		},
		mounted() {
			var appVue = this;
			// if (appVue.$store.state.config == null) {
			// 	appVue.$store.dispatch("loadConfig");
			// }
					
			// if (appVue.$store.state.neigh == null) {
			// 	appVue.$store.dispatch("loadNeigh");
			// }
				appVue.$store.state.searchType = "SETTLEMENT";

				if (appVue.$route.query.view == "settlement") {
					appVue.$store.state.setlCode = appVue.$route.query.id;
				}
				appVue.$store.state.deals = [];
				try {
					appVue.mixin_fetchPageData(
						appVue,
						"SETTLEMENT",
						appVue.$store.state.setlCode,
						appVue.$store.state.config.api_base,
					).then(function () {
						appVue.$store.dispatch("loadSetlTypes").then(() => {
							var setlTypeObj = appVue.$store.state.setlTypes[
								appVue.$store.state.setlCode
							];
							if (setlTypeObj != null) {
								if (setlTypeObj.GLOBAL_TYPE == "קיבוצים"){
									appVue.$store.state.luxury = null;
								}
							}
						});
					});
				} catch (error) {
					console.log("error", error);
					appVue.$router.push({
						name: "notfound",
						query: { view: "notfound" },
					});
				}

				const d_url =
					appVue.$store.state.config.s3_page_base +
					"/settlement/buy/" +
					appVue.$store.state.setlCode +
					".json";
				try {
					fetch(d_url).then(function (response) {
						if (!response.ok) {
							appVue.$router.push({
								name: "notfound",
								query: { view: "notfound" },
							});
						} else {
							const data = response.json();
							data.then(function (e) {
								if (appVue.$store.state.neighborhoodName == null) {
									appVue.$store.state.neighborhoodName = e.neighborhoodName;
								}
								if (appVue.$store.state.settlementName == null) {
									appVue.$store.state.settlementName = e.settlementName;
								}
								if (
									Object.prototype.hasOwnProperty.call(e, "otherNeighborhoods")
								) {
									appVue.$store.state.otherSettlmentStreets =
										e.otherSettlmentStreets;
								}
								appVue.$store.state.isMain = false;
								appVue.mixin_setTrendsData(appVue, e);
							});
						}
					});
				} catch (error) {
					appVue.$router.push({
						name: "notfound",
						query: { view: "notfound" },
					});
				}
		},
	};
</script>
